module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"agreeRecurrent":"Я даю согласие на регулярные списание с карты","agreePublic":"Принимаю условия публичной ","offer":"оферты","confirm":"Подтвердить оплату"}}')
  delete Component.options._Ctor
}
